const data: string = "<h3 ng-if=\"shouldShowTitle()\" cms-html=\"cs-title:components/contact-cs\"></h3><p cms-html=\"cs-copy:components/contact-cs\" ng-click=\"openExternalLink($event)\"></p>";
export default data